import { useState } from 'react';
import { Button } from '../../components/Button';
import { api } from '../../lib/api';
import { useStore } from '../../store/StoreProvider';
import { SettingsBlock } from './SettingsBlock';

// Impostazioni › Backup (tela, artboard 38): la configurazione in un file JSON, senza segreti
// (poptown.backup sul server).
export function BackupTab() {
  const { toast } = useStore();
  const [busy, setBusy] = useState(false);

  const download = () => {
    setBusy(true);
    api
      .backup()
      .then((data) => {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `poptown-config-${new Date().toISOString().slice(0, 10)}.json`;
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch((e: Error) => toast({ kind: 'danger', title: 'Backup non riuscito', body: e.message }))
      .finally(() => setBusy(false));
  };

  return (
    <SettingsBlock
      over="Backup"
      title="Configurazione"
      hint="Progetti, pop e prompt cambiati, attività di Pianifica, integrazioni e preferenze in un file JSON. Nessun token, chiave o password: dopo un ripristino si reinseriscono in Provider, Git e Strumenti."
      control={
        <Button size="sm" icon="download" loading={busy} onClick={download}>
          Scarica la configurazione
        </Button>
      }
    />
  );
}
